<h4>Untersuchung starten</h4>
<div>
<span ng-repeat="et in esCtrl.alltemplates | filter:{ active: true } " ng-show="esCtrl.alltemplates">

  <span class="btn btn-primary btn-spacer-top"
          ng-click="esCtrl.startExam(et);">{{et.template.displayname}}
  </span>
</span>
</div>
